import { GridLegacy } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";

function Algemeen() {
  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <FormTextTC name={"zoneName"} tDefault={"Zone name"} tKey={"tafels.form.algemeen.label.zoneName"} />
          <FormTextTC
            name={"zoneDescription"}
            tDefault={"Zone description"}
            tKey={"tafels.form.algemeen.label.zoneDescription"}
          />
          <FormSwitchTC
            name={"disableTables"}
            tDefault={"Disable all tables for this zone"}
            tKey={"zones.form.algemeen.label.disableTables"}
          />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
